import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

 
import Dashboard from "./components/dashboard/Dashboard";
import EventSeries from "./components/eventSeries/EventSeries";
import EditEventSeries from "./components/eventSeries/EditEventSeries";
import EditEvent from "./components/eventSeries/EditEvent";
import { DataProvider } from "./providers/DataProvider";
import DynamicEventSeriesForm from "./components/eventSeries/DynamicEventSeriesForm";
import { DataHandlerProvider } from "./providers/DataHandlerProvider";
import AddEvents from "./components/eventSeries/AddEvents";
import GoogleLogin from "./components/auth/GoogleLogin";
import { SignInProvider } from "./providers/SignInProvider";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { NavbarProvider } from "./providers/NavbarProvider";
import MarkFormCard from "./components/mark_form/MarkFormCard";
import MarkFormEdit from "./components/mark_form/MarkFormEdit";

import DynamicForm from "./components/mark_form/DynamicForm";
import CreateDynamicForm from "./components/draggable/ModifyDynamicForm";
import { DndContext } from "@dnd-kit/core";
import CreateDynamicEventSeriesForm from "./components/draggable/ModifyDynamicEventSeriesForm";
import StatisticsPage from "./components/eventSeries/StatisticsPage";
import ScrollToTop from "./components/ScrollToTop";
import CopperDuplicatesPage from "./components/CopperDuplicatesPage";
import IframeRedirectTest from "./components/IframeRedirectTest";

const SecureRoutes = () => {
  return (
    <ProtectedRoute>
      <NavbarProvider>
        <DataHandlerProvider>
          <Outlet />
        </DataHandlerProvider>
      </NavbarProvider>
    </ProtectedRoute>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
        <Routes>


          <Route
            path="/"
            element={
              <SignInProvider>
                <GoogleLogin />
              </SignInProvider>
            }
          />

          <Route
            path="/events-series/:eventseriesid"
            element={
              <DataProvider>
                <DynamicEventSeriesForm />
              </DataProvider>
            }
          />

            <Route
              path="/:formType/form/:formid/view"
              element={
                <DataProvider>
                  <DynamicForm />
                </DataProvider>
              }
            />

            {/* <Route
              path="/:formType/testiframe/view/"
              element={
                <DataProvider>
                  <IframeRedirectTest />
                </DataProvider>
              }
            /> */}
         

          <Route
            element={
              <SignInProvider>
                <DataProvider>
                  <SecureRoutes />
                </DataProvider>
              </SignInProvider>
            }
          >


            {/* Dashboard  */}
            <Route path="/home" element={<Dashboard />} />

            {/* Main   */}
            <Route path="/:eventSerieType/events-series/:eventseriesid" element={<EventSeries />} />
            <Route path="/:formType/form/:formid" element={<MarkFormCard />} />

            <Route path="/:eventSerieType/events-series/:eventseriesid/show-disabled-events" element={<EventSeries />} />

            {/* Main - edit  */}
             <Route path="/:eventSerieType/events-series/:eventseriesid/edit" element={<EditEventSeries />} />
             <Route path="/:formType/form/:formid/edit" element={<MarkFormEdit />}/>



            {/* Main - add  */}
            <Route path="/:eventSerieType/events-series/:eventseriesid/add" element={<AddEvents />} />
            
             {/* Event - edit  */}
             <Route
              path="/:eventSerieType/events-series/:eventseriesid/event/:eventid/edit"
              element={<EditEvent />}
            />
            
            {/* Event - Statistics  */}
            <Route
              path="/:eventSerieType/events-series/:eventseriesid/statistics"
              element={<StatisticsPage />}
            />
            
            <Route path="/:eventSerieType/events-series/:eventseriesid/view" element={<DynamicEventSeriesForm />} />
 
            <Route
              path="/getduplicatesleads"
              element={<CopperDuplicatesPage />}
            />
            {/* TESTING DYNAMIC FORMS */}
 
            <Route
              path="/:formType/form/:formid/create"
              element={
                <DataProvider>
                  <DndContext>
                  <CreateDynamicForm />
                  </DndContext>
                </DataProvider>
              }
            />


            <Route
              path="/:eventSerieType/events-series/:eventseriesid/create"
              element={
                <DataProvider>
                  <DndContext>
                  <CreateDynamicEventSeriesForm />
                  </DndContext>
                </DataProvider>
              }
            />
          </Route>


          <Route path="*"  element={
              <SignInProvider>
                <GoogleLogin />
              </SignInProvider>
            } /> 


        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
